import { Attr, BelongsTo, HasMany, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import Workstation from './workstation';
import WorkstationBootAttempt from './workstation_boot_attempt';
import { isBootPending, stepFunctionUrl } from '../shared/boot_feedback';

@Model()
export default class WorkstationBoot extends ApplicationRecord {
  static jsonapiType = 'workstation_boots';
  @Attr() state: string;
  @Attr() phase: string;
  @Attr() forceRebuild: boolean;
  @Attr() latest: boolean;
  @Attr() executionArn: string;
  @Attr() bootScheduleRunId: string;
  @Attr() attemptsPerType: number;
  // Instance type identifiers in the order the boot tries them.
  @Attr() plannedInstanceTypes: string[];
  // False when the account's boot service doesn't report its attempts.
  @Attr() reportsAttempts: boolean;
  @Attr() createdAt: string;
  @Attr() updatedAt: string;

  @BelongsTo() workstation: Workstation;
  // Oldest first.
  @HasMany(WorkstationBootAttempt) capacityAttempts: WorkstationBootAttempt[];

  // The workstation's most recent boots with their attempts, newest first.
  static recentForWorkstation(workstationId: string, count = 10) {
    return this.where({ workstation_id: workstationId })
      .includes('capacity_attempts')
      .order({ created_at: 'desc' })
      .per(count)
      .all();
  }

  isPending() {
    return isBootPending(this);
  }

  stepFunctionUrl() {
    return stepFunctionUrl(this.executionArn);
  }
}
